import { createContext, useEffect, useMemo, useRef } from 'react';
import CustomRoutineActivities from './CustomRoutineActivities';
import CustomRoutineName from './CustomRoutineName';
import CustomRoutineOptions from './custom-routine-options';
import { CustomRoutineType } from 'interfaces/setting.interface';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateIsNewCustomRoutineAppended } from 'store/reducer/setting/slice';
import { customRoutineSelector } from 'store/reducer/setting/selectors';

interface CustomRoutineProps {
  customRoutine: CustomRoutineType;
  position: number;
}
export interface CustomRoutineContextType extends CustomRoutineType {
  position: number;
}

export const CustomRoutineContext = createContext<
  CustomRoutineContextType | undefined
>(undefined);

const CustomRoutine = ({ customRoutine, position }: CustomRoutineProps) => {
  const dispatch = useAppDispatch();
  const dummyDiv = useRef<HTMLDivElement>(null);
  const isNewCustomRoutineAppended = useAppSelectorShallow(
    customRoutineSelector
  );

  useEffect(() => {
    if (isNewCustomRoutineAppended) {
      dummyDiv.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
      dispatch(updateIsNewCustomRoutineAppended(false));
    }
  }, [isNewCustomRoutineAppended, dispatch]);

  return (
    <div
      className='w-full flex flex-col items-center ~gap-6/4 ~p-2/5'
      data-testid='custom-routine-editor-wrapper'>
      <CustomRoutineContext.Provider
        value={useMemo(
          () => ({ ...customRoutine, position }),
          [customRoutine, position]
        )}>
        <CustomRoutineName />
        <CustomRoutineOptions />
        <CustomRoutineActivities />
        <div className='float-left clear-both' ref={dummyDiv}></div>
      </CustomRoutineContext.Provider>
    </div>
  );
};

export default CustomRoutine;
